import { Subscription } from 'rxjs';
import { Component, Input, OnInit, OnDestroy} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../core/services/event.service';
import { NgClass } from '@angular/common';
import { CameraComponent } from '../camera/camera.component';

@Component({
    selector: 'video-record-modal',
    templateUrl: './video-record-modal.component.html',
    styleUrls: ['./video-record-modal.component.scss'],
    imports: [CameraComponent, NgClass]
})
export class VideoRecordModalComponent implements OnInit, OnDestroy {
	private subs = new Subscription();


	public recordTimeLimit: number = 60;
	public videoData: any;
	public timerText: string = ('0' + this.recordTimeLimit).slice(-2);
	public showRecordButton: boolean = true;
	public isMuted: boolean = true;
	public isRecording: boolean = false;

	private stream: any;
	private countdownTimer: any;

	constructor(private eventService: EventService,
		private modal: NgbActiveModal) {

	}

	ngOnInit() {
		this.subs.add(this.eventService.subscribe('camera-recording-complete', (value) => {
			this.videoData = value;
		}));
	}

	changeRecorderClass() {
		if (!this.isRecording) {
			// start recording
			this.startTimer();
			this.eventService.broadcast('start-recording-camera', {});
		} else {
			// stop recording
			clearInterval(this.countdownTimer);
			this.eventService.broadcast('stop-recording-camera', {});
			this.showRecordButton = false;
		}
		this.isRecording = !this.isRecording;
	}

	retakeVideo() {
		this.isRecording = false;
		this.showRecordButton = true;
		this.eventService.broadcast('camera-on', {});
	}

	selectVideo() {
		if (!this.videoData) return;
		this.eventService.broadcast('video-selected', { data: this.videoData });
		this.close();
	}

	private startTimer() {
		let recordTimeLimit = 60;
		this.recordTimeLimit = recordTimeLimit;
		this.timerText = ('0' + this.recordTimeLimit).slice(-2);
		this.countdownTimer = setInterval(() => {
			this.recordTimeLimit = this.recordTimeLimit - 1;
			this.timerText = ('0' + this.recordTimeLimit).slice(-2);
			if (this.recordTimeLimit === 0) {
				clearInterval(this.countdownTimer);
				this.eventService.broadcast('stop-recording-camera', {});
				this.isRecording = !this.isRecording;
				this.showRecordButton = false;
			}
		}, 1000);
	}

	close() {
		this.eventService.broadcast('dismiss-camera', {});
		this.modal.dismiss();
	}


	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
